import { Component, inject } from '@angular/core';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-delete-organization-dialog',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
  ],
  templateUrl: './delete-organization-dialog.html',
  styleUrl: './delete-organization-dialog.scss',
})
export class DeleteOrganizationDialog {
  private readonly dialogRef = inject(MatDialogRef<DeleteOrganizationDialog>);

  public onUserClick(deleteOrganization: boolean): void {
    this.dialogRef.close(deleteOrganization);
  }
}
